import script from "./QuestionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionPage.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionPage.vue?vue&type=style&index=0&id=f15f5796&lang=scss"

const __exports__ = script;

export default __exports__